export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
/** Global extract of emails from free-text / HTML chunks. */
export const EMAIL_EXTRACT_RE = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi
export const MAILTRAP_BASE_URL = 'http://mailtrap.immensotech.com'
